<!-- Visible only while the dynamically-imported SciChart chunk is on the wire.
     The chart containers below stay mounted throughout: SciChartSurface.create()
     resolves them by id and cannot wait for *ngIf. -->
<!-- ONE LOADING STATEMENT AT A TIME.
     Two indicators answer two different questions: the full-screen overlay in
     main-layout means DATA is in flight, this one means the SciChart chunk is
     still on the wire. Both were rendered together on a first visit, which is
     where "we have a loading spinning wheel and scicharts has a native loading
     chart data" came from — two spinners, no indication they meant different
     things. The overlay is the outer, blocking state, so it wins; this appears
     only once data has settled and the chunk alone is outstanding. -->
<div
  class="chart-loading"
  *ngIf="!chartsReady && !(projectService.inFlightTelemetry | async)"
>
  {{ 'CuringLoadingCharts' | t }}
</div>
<div class="main-wrapper">
  <div class="all-charts-container">
    <app-cure-sheet-list class="curing-cure-sheets"></app-cure-sheet-list>
    <div class="curing-legends">
      <!-- `[]` IS A REAL STATE, not an error and not a load in progress. 59 of 80
           desktop projects declare no heat-input stages at all, and a curing chart
           showing only the curing band with no explanation looks like a chart that
           failed to load four series. Say so in words. -->
      <span class="no-stages" *ngIf="noStagesConfigured">{{
        'CuringNoHeatInputStages' | t
      }}</span>
    </div>
    <div class="offline-hatch-wrap">
      <div [id]="curingGraphId" class="curing-graph"></div>
      <!-- The desktop's hatched mountains. SciChart's mountain fill takes a
           colour, not a brush, so the hatch is painted above the WebGL surface
           and clipped to each band — see CuringBandHatchComponent. -->
      <app-curing-band-hatch></app-curing-band-hatch>
      <app-offline-hatch></app-offline-hatch>
    </div>
    <div class="rng_slider_container">
      <div class="rng_sliders_control" *ngIf="showRangeSlider">
        <input
          id="fromSlider"
          type="range"
          value="0"
          min="0"
          max="100"
          #fromSlider
          (input)="updateChartVisibleRange(fromSlider.value, toSlider.value)"
        />
        <input
          id="toSlider"
          type="range"
          value="100"
          min="0"
          max="100"
          #toSlider
          (input)="updateChartVisibleRange(fromSlider.value, toSlider.value)"
        />
      </div>
    </div>
  </div>
  <div class="chart-controls">
    <div class="controls-top">
      <div class="help-btn" (click)="toggleHelpOverlay()">
        <img src="../../assets/Help/Help.svg" alt="" class="help-btn-img" />
      </div>
      <ul>
        <li
          (click)="setRollOver(true)"
          [class]="[rolloverModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link1"></a>
          <img
            src="../../assets/Help/Inspect.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li
          (click)="setPan(true)"
          [class]="[zoomPanModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link2"></a>
          <img
            src="../../assets/Help/Drag.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li
          (click)="setZoom(true)"
          [class]="[rubberBandZoomModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link3"></a>
          <img
            src="../../assets/Help/Zoom.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
      </ul>
    </div>
    <div class="controls-top">
      <ul>
        <li (click)="zoomOut()">
          <a [routerLink]="" class="link4"></a>
          <img
            src="../../assets/Help/Zoom out.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li (click)="toggleRangeSlider()">
          <a [routerLink]="" class="link5"></a>
          <img
            src="../../assets/Help/Show Hide Zoom Control.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
      </ul>
    </div>
    <div class="controls-spacer"></div>
    <div class="controls-bottom">
      <ul>
        <li (click)="addMarker()">
          <a [routerLink]="" class="link6"></a>
          <img
            src="../../assets/Help/Add Marker .svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li>
            <!-- Camera. Captures ONE named surface and the tooltip says which,
                 because a screen-level control bar cannot sit beside its chart
                 the way the desktop's per-chart camera does. -->
            <a
              [routerLink]=""
              class="link7"
              [appChartScreenshot]="'curingGraph'"
              chartLabel="Curing"
              [projectName]="projectService.selectedProjectName"></a>
          </li>
      </ul>
    </div>
  </div>
</div>
